module.exports = __webpack_public_path__ + "img/5.ae20200f.png";